<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.id || index" :row-index="index + 1">
      <van-row class="detail-row">
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>变更前限制类型：</span>
        <span>{{ item.dueTypeOrigin | dictFilter(dueTypeOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>变更后限制类型：</span>
        <span>{{ item.dueType | dictFilter(dueTypeOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>变更前开单周期(天)：</span>
        <span>{{ item.cycleOrigin }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>变更后开单周期(天)：</span>
        <span>{{ item.cycle }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'DeliveryDueModifyMaterialList',
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dueTypeOptions() {
      return this.$store.getters.dicts.asn_due_type
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-row span:first-child {
  color: #666666;
}
.detail-row span:last-child {
  color: #262626;
}
</style>
